import React, { useState } from 'react';
import './index.css';
import Home from './pages/Home';
import Detail from './pages/Detail';

export default function App() {
  const [page, setPage] = useState('home');
  const [selectedId, setSelectedId] = useState(null);

  const navigate = (to, id = null) => {
    setSelectedId(id);
    setPage(to);
    window.scrollTo(0, 0);
  };

  if (page === 'detail' && selectedId) {
    return <Detail id={selectedId} onBack={() => navigate('home')} />;
  }
  return <Home onSelect={(id) => navigate('detail', id)} />;
}
